import kebabCase from 'lodash/kebabCase';
import { FontAttributes } from '@loyalty/shared-common/template-api-client';

/**
 * These fonts are loaded in get-participant.ts but we only load Ralexay and Open Sans
 * because Helvetica, Times New Roman are not available in Google Fonts and should be
 * available in the browser by default.
 */
export const defaultFonts = [
  { name: 'Raleway', settings: {} } as FontAttributes,
  { name: 'Open Sans', settings: {} } as FontAttributes,
  { name: 'Helvetica', settings: {} } as FontAttributes,
  { name: 'Times New Roman', settings: {} } as FontAttributes,
];

/*
 * Quill uses kebab-case for font names in the class names it generates for the selected text.
 * However, you cannot use dashes, otherwise, Quill outputs correct HTML but will remove the
 * spans with ql-font-<font-name> classes when initializing the editor with content.
 */
export function getQuillFontName(name: string): string {
  return kebabCase(name).replace(/-/g, '');
}

/*
 * When you set a font on a selected text in Quill, it generates <span class="ql-font-<kebab-case-font-name>">my text</span>
 * This CSS needs to be injected in the GrapesJS editor canvas, and wherever the Quill HTML content will be used (member portal).
 * Inspiration: https://stackoverflow.com/a/53487445
 */
export function getFontsContentCss(fonts: FontAttributes[]): string {
  return fonts
    .map(({ name }) => {
      const alias = getQuillFontName(name);
      return `.ql-font-${alias} {font-family: '${name}'; }`;
    })
    .join('\n');
}

/*
 * This css styles Quill's toolbar font selection dropdown so that font names are correctly shows.
 * Otherwise Quill shows "Sans Serif" for every font.
 * * Inspiration: https://stackoverflow.com/a/53487445
 */
export function getFontsToolbarCss(fonts: FontAttributes[]) {
  return `
.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-options .ql-picker-item::before
{
  content: 'Default' !important;
}

    ${fonts
      .map(({ name }) => {
        const alias = getQuillFontName(name);
        return `
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='${alias}']::before,
.ql-snow .ql-picker.ql-font .ql-picker-options .ql-picker-item[data-value='${alias}']::before
{
  content: '${name}' !important;
  font-family: '${name}' !important;

  display: inline-block;
  max-width: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
`;
      })
      .join('\n')}
      `;
}
